export default {
    props: {
        groupAggregates: {
            type: Array,
            kComposite: 'group.aggregates'
        },
        groupDir: {
            type: String,
            kComposite: 'group.dir'
        }, 
        groupField: {
            type: String,
            kComposite: 'group.field'
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-datasource-vue-wrapper/src/KendoDataSourceBase/Group.js